var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 60,
    height: 60,
    rx: 7,
    fill: "#005587"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8333 18V21.3333C23.8333 22 23.8333 23.3333 25.8333 23.3333H35.1667C37.1667 23.3333 37.1667 22 37.1667 21.3333V18H38.921C40.1613 18 41.1667 19.0234 41.1667 20.2857V41.0476C41.1667 42.31 40.1613 43.3334 38.921 43.3334H22.0789C20.8387 43.3334 19.8333 42.31 19.8333 41.0476V20.2857C19.8333 19.0234 20.8387 18 22.0789 18H23.8333ZM25.8333 30.8889C25.4651 30.8889 25.1667 31.1873 25.1667 31.5555V33.7778C25.1667 34.1459 25.4651 34.4444 25.8333 34.4444H28.7222V37.3333C28.7222 37.7015 29.0207 38 29.3889 38H31.6111C31.9793 38 32.2778 37.7015 32.2778 37.3333V34.4444H35.1667C35.5349 34.4444 35.8333 34.1459 35.8333 33.7778V31.5555C35.8333 31.1873 35.5349 30.8889 35.1667 30.8889H32.2778V28C32.2778 27.6318 31.9793 27.3333 31.6111 27.3333H29.3889C29.0207 27.3333 28.7222 27.6318 28.7222 28V30.8889H25.8333ZM25.1667 21.3333L25.1667 18C25.8334 18 25.1668 18 27.8334 18C27.8333 16 29.1667 15.3333 30.5 15.3333C31.8333 15.3333 33.1667 16 33.1667 18C33.1667 18 35.1667 18 35.8334 18L35.8333 21.3333C35.8333 21.3333 35.8333 22 35.1667 22H25.8333C25.1667 22 25.1667 21.3333 25.1667 21.3333ZM30.5 16.6667C29.7636 16.6667 29.1667 17.2636 29.1667 18C29.1667 18.7364 29.7636 19.3333 30.5 19.3333C31.2364 19.3333 31.8333 18.7364 31.8333 18C31.8333 17.2636 31.2364 16.6667 30.5 16.6667Z",
    fill: "#80AAC3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.a76fae6f.svg";
export { ForwardRef as ReactComponent };